import React, { useState } from 'react';
import './DiseasesSection.css';

const diseases = [
  { crop:'tomato', emoji:'🍅', bg:'linear-gradient(135deg,#2a1a10,#5a3020)', name:'Tomato Early Blight',   severity:'high', desc:'Caused by Alternaria solani. Brown spots with concentric rings appear on older leaves first.' },
  { crop:'tomato', emoji:'🔴', bg:'linear-gradient(135deg,#1a102a,#402860)', name:'Tomato Late Blight',    severity:'high', desc:'Caused by Phytophthora infestans. Rapid brown-black lesions on leaves, stems, and fruit.' },
  { crop:'tomato', emoji:'🟡', bg:'linear-gradient(135deg,#2a2a10,#5a5a20)', name:'Yellow Leaf Curl Virus',severity:'med',  desc:'Caused by TYLCV virus transmitted by whiteflies. Curling and yellowing of leaves.' },
  { crop:'tomato', emoji:'🌿', bg:'linear-gradient(135deg,#102a10,#205a20)', name:'Bacterial Spot',         severity:'med',  desc:'Caused by Xanthomonas bacteria. Small dark spots with yellow halos on leaves and fruit.' },
  { crop:'maize',  emoji:'🌽', bg:'linear-gradient(135deg,#1a1a2a,#3a3a5a)', name:'Gray Leaf Spot',         severity:'high', desc:'Caused by Cercospora zeae-maydis. Rectangular tan lesions running parallel to leaf veins.' },
  { crop:'maize',  emoji:'🟤', bg:'linear-gradient(135deg,#2a1a10,#5a3820)', name:'Northern Leaf Blight',   severity:'high', desc:'Caused by Exserohilum turcicum. Large cigar-shaped tan lesions on leaves.' },
  { crop:'maize',  emoji:'🌾', bg:'linear-gradient(135deg,#2a1510,#5a3010)', name:'Common Rust',             severity:'med',  desc:'Caused by Puccinia sorghi. Brick-red pustules scattered across both leaf surfaces.' },
  { crop:'maize',  emoji:'🟫', bg:'linear-gradient(135deg,#1a1a10,#3a3a20)', name:'Southern Corn Leaf Blight',severity:'med', desc:'Caused by Bipolaris maydis. Tan lesions with tan borders on leaves.' },
];

export default function DiseasesSection() {
  const [filter, setFilter] = useState('all');
  const filtered = filter === 'all' ? diseases : diseases.filter(d => d.crop === filter);

  return (
    <section id="diseases">
      <div className="container">
        <div className="text-center mb-5 reveal">
          <span className="section-label">Disease Library</span>
          <h2 className="section-title">
            Common Crop <span className="accent">Diseases</span>
          </h2>
          <p className="section-desc mx-auto">
            Explore our database of tomato and maize diseases with symptoms and treatment guides.
          </p>
          <div className="mt-4">
            <span className={`filter-tab ${filter === 'all'    ? 'active' : ''}`} onClick={() => setFilter('all')}>All Diseases</span>
            <span className={`filter-tab ${filter === 'tomato' ? 'active' : ''}`} onClick={() => setFilter('tomato')}>🍅 Tomato</span>
            <span className={`filter-tab ${filter === 'maize'  ? 'active' : ''}`} onClick={() => setFilter('maize')}>🌽 Maize</span>
          </div>
        </div>

        <div className="row g-4">
          {filtered.map((d, i) => (
            <div className="col-md-6 col-lg-3 reveal" key={i}>
              <div className="disease-card">
                <div className="disease-img" style={{ background: d.bg }}>{d.emoji}</div>
                <div className="disease-body">
                  <span className={`crop-badge crop-${d.crop}`}>
                    {d.crop === 'tomato' ? '🍅 Tomato' : '🌽 Maize'}
                  </span>
                  <div className="disease-title">{d.name}</div>
                  <div className="disease-desc">{d.desc}</div>
                  <div className="mt-2" style={{ fontSize: '.78rem', color: 'var(--text-muted)' }}>
                    <span className={`severity-dot sev-${d.severity}`}></span>
                    {d.severity === 'high' ? 'High Severity' : 'Medium Severity'}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
